import {Modal} from '@mantine/core';
import React, {useEffect, useState} from 'react';

import MapBox, {NavigationControl} from 'react-map-gl';

import {Marker, ShadowEllipsis, Footer, LoadingContainer} from './styles';
import {HiLocationMarker} from 'react-icons/hi';
import Button from 'shared/migration-components/button';
import {AddressProps} from 'modules/addresses/types';
import useCoordinatesByAddress from 'modules/addresses/hooks/use-coordinates-by-address';
import Loading from 'shared/migration-components/loading';
import useAddressByCoordinates from 'modules/addresses/hooks/use-address-by-coordinates';
import {CoordinatesProps} from 'shared/types/coordinates';
import {useTheme} from 'styled-components';

interface Props {
  onClose: () => void;
  onConfirm: (coords: any) => void;
  addressDraft?: AddressProps;
}

const Map: React.FC<Props> = ({onClose, onConfirm, addressDraft}) => {
  const [isMoving, setIsMoving] = useState(false);
  const [coords, setCoords] = useState<CoordinatesProps>();
  const {colors} = useTheme();

  const {data, isLoading} = useCoordinatesByAddress(addressDraft);

  const latitude = data?.latitude ?? addressDraft?.latitude;
  const longitude = data?.longitude ?? addressDraft?.longitude;

  const addressByCoordinatesQuery = useAddressByCoordinates(
    coords ?? ({} as CoordinatesProps),
  );

  const viewport = {
    latitude: latitude ?? -14.7478363,
    longitude: longitude ?? -52.9522726,
    zoom: addressDraft?.latitude || data?.latitude ? 16 : 4,
    bearing: 0,
    pitch: 0,
  };

  useEffect(() => {
    if (latitude && longitude) setCoords({latitude, longitude});
  }, [latitude, longitude]);

  const handleSubmit = async () => {
    onConfirm(coords ?? addressDraft!);
  };

  return (
    <Modal
      opened
      {...{onClose}}
      size={1000}
      withCloseButton={false}
      styles={{
        content: {padding: 0, margin: 0},
        root: {padding: 0, margin: 0},
        inner: {padding: 0, margin: 0},
        body: {padding: 0, margin: 0},
      }}>
      {isLoading && (
        <LoadingContainer>
          <Loading />
        </LoadingContainer>
      )}
      {!isLoading && (
        <>
          <MapBox
            attributionControl={false}
            initialViewState={viewport}
            style={{width: '100%', height: 800}}
            mapStyle="mapbox://styles/mapbox/streets-v12"
            mapboxAccessToken="pk.eyJ1Ijoia29lcGUiLCJhIjoiY2w2YmRydmlxNG82bTNkbzFmMzhwZm80diJ9.BPqRBxjeD6I8pQa0p1zevw"
            onMoveStart={() => setIsMoving(true)}
            onMoveEnd={(e) => {
              setCoords({
                latitude: e.viewState.latitude,
                longitude: e.viewState.longitude,
              });
              setIsMoving(false);
            }}>
            <NavigationControl position="bottom-right" />
          </MapBox>
          <Marker {...{isMoving}}>
            <HiLocationMarker
              size={30}
              color={isMoving ? 'black' : colors.primary}
            />
          </Marker>
          <ShadowEllipsis />
          <Footer>
            <Button
              title="Confirmar"
              disabled={!coords && !addressDraft?.latitude}
              onClick={handleSubmit}
              widthMode="fit-content"
              loading={
                addressByCoordinatesQuery.isLoading ||
                addressByCoordinatesQuery.isRefetching
              }
            />
          </Footer>
        </>
      )}
    </Modal>
  );
};

export default Map;
